import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const UserProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const checkUserToken = () => {
    const userToken = localStorage.getItem("user_token");
    if (!userToken || userToken === "undefined") {
      localStorage.removeItem("user_token");
      setIsLoggedIn(false);
      return navigate("/login");
    } else {
      setIsLoggedIn(true);
    }
  };
  useEffect(() => {
    checkUserToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <>{isLoggedIn ? children : null}</>;
};

export default UserProtectedRoute;
